import React, { useEffect, useState } from 'react'
import { Popover, Box, Switch, FormControlLabel } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import theme from '../../theme'
import { setAdvancedSearch } from '../../redux/slices/Search/input'

const anchorOrigin = {
  vertical: 'top',
  horizontal: 'right',
}

const transformOrigin = {
  vertical: 'top',
  horizontal: 'left',
}

const StyledPopoverContainer = ({
  id,
  open,
  anchorEl,
  position = { top: 100, left: 75 },
  onClose,
  children,
}) => {
  const dispatch = useDispatch()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const advancedSearch = useSelector(state => state.filterSearch.advancedSearch)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Popover
      id={id}
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={position}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      sx={{
        maxWidth: '100vw',
        width: 'auto',
      }}>
      <Box
        sx={{
          p: 2,
          maxWidth: 'calc(100vw - 148px)',
          backgroundColor: '#ffffff96',
          borderRadius: 1,
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 150px)',
          backdropFilter: 'blur(2px)',
        }}>
        <FormControlLabel
          control={
            <Switch
              checked={advancedSearch}
              onChange={() => dispatch(setAdvancedSearch(!advancedSearch))}
              color="primary"
              size="small"
            />
          }
          label="Búsqueda Avanzada"
          labelPlacement="end"
          sx={{
            ml: 1,
            mb: 1,
            '& .MuiFormControlLabel-label': {
              fontSize: '0.9rem',
              color: theme.palette.primary.dark,
              fontWeight: 600,
            },
          }}
        />
        {typeof children === 'function' ? children({ windowWidth }) : children}
      </Box>
    </Popover>
  )
}

export default StyledPopoverContainer
